export default {
  data() {
    return {
      selectedGroup: ''
    };
  },
  computed: {
    groupStr() {
      return this.isGrouporgProjectCenter ? 'group' : '';
    },
    /** @returns {'offlineExam' | 'onlineExam' | 'practice'} */
    arrangeType() {
      return this.$route.query.examType;
    }
  },
  methods: {
    setSelectedGroup(value = {}, params, fn, fnParam) {
      try {
        this.selectedGroup = value.orgId;
      } catch (e) {
      }
      if (typeof params === 'object') {
        params.queryOrgId = value.orgId;
      }
      if (fnParam) {
        fn && fn(fnParam);
      } else {
        fn && fn();
      }
    }
  }

};
